export type IconTypeKeys =
  | "Active"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowUp"
  | "ArrowsUpDown"
  | "Assembly"
  | "BallBearing"
  | "Bell"
  | "Bin"
  | "Bookmark"
  | "Building"
  | "Cad"
  | "Calculator"
  | "Calendar"
  | "Camera"
  | "Cart"
  | "CheckCircleOutline"
  | "CheckCircle"
  | "Check"
  | "Checklist"
  | "ChevronDown"
  | "ChevronLeft"
  | "ChevronRight"
  | "ChevronUp"
  | "Clock"
  | "Close"
  | "Cog"
  | "CommentEmpty"
  | "CommentPlus"
  | "Comment"
  | "CopyToClipboard"
  | "Cup"
  | "Disk"
  | "DmcScan"
  | "Download"
  | "EnvelopeOpen"
  | "Envelope"
  | "ErrorCircle"
  | "EyeOff"
  | "Eye"
  | "FileCheck"
  | "FileClock"
  | "FileError"
  | "FileList"
  | "FilePencil"
  | "FilePlus"
  | "Filter"
  | "FlashlightOff"
  | "FlashlightOn"
  | "FolderOpen"
  | "History"
  | "Home"
  | "InfoCircleOutline"
  | "InformationCircle"
  | "Invitation"
  | "Lightbulb"
  | "Link"
  | "List"
  | "Location"
  | "Lock"
  | "Minus"
  | "More"
  | "Newspaper"
  | "OpenInNew"
  | "Pages"
  | "Pdf"
  | "Pencil"
  | "Phone"
  | "Plus"
  | "PriceTag"
  | "Printer"
  | "QuestionMarkCircle"
  | "Reload"
  | "Reset"
  | "ScreenNews"
  | "Search"
  | "Share"
  | "Star"
  | "Tiles"
  | "TreeView"
  | "Trending"
  | "User"
  | "Warning"
  | "ZcaretDown"
  | "ZcaretUp";

export enum IconType {
  Active = "scha-icon-active",
  ArrowDown = "scha-icon-arrow-down",
  ArrowLeft = "scha-icon-arrow-left",
  ArrowUp = "scha-icon-arrow-up",
  ArrowsUpDown = "scha-icon-arrows-up-down",
  Assembly = "scha-icon-assembly",
  BallBearing = "scha-icon-ball-bearing",
  Bell = "scha-icon-bell",
  Bin = "scha-icon-bin",
  Bookmark = "scha-icon-bookmark",
  Building = "scha-icon-building",
  Cad = "scha-icon-cad",
  Calculator = "scha-icon-calculator",
  Calendar = "scha-icon-calendar",
  Camera = "scha-icon-camera",
  Cart = "scha-icon-cart",
  CheckCircleOutline = "scha-icon-check-circle-outline",
  CheckCircle = "scha-icon-check-circle",
  Check = "scha-icon-check",
  Checklist = "scha-icon-checklist",
  ChevronDown = "scha-icon-chevron-down",
  ChevronLeft = "scha-icon-chevron-left",
  ChevronRight = "scha-icon-chevron-right",
  ChevronUp = "scha-icon-chevron-up",
  Clock = "scha-icon-clock",
  Close = "scha-icon-close",
  Cog = "scha-icon-cog",
  CommentEmpty = "scha-icon-comment-empty",
  CommentPlus = "scha-icon-comment-plus",
  Comment = "scha-icon-comment",
  CopyToClipboard = "scha-icon-copy-to-clipboard",
  Cup = "scha-icon-cup",
  Disk = "scha-icon-disk",
  DmcScan = "scha-icon-dmc-scan",
  Download = "scha-icon-download",
  EnvelopeOpen = "scha-icon-envelope-open",
  Envelope = "scha-icon-envelope",
  ErrorCircle = "scha-icon-error-circle",
  EyeOff = "scha-icon-eye-off",
  Eye = "scha-icon-eye",
  FileCheck = "scha-icon-file-check",
  FileClock = "scha-icon-file-clock",
  FileError = "scha-icon-file-error",
  FileList = "scha-icon-file-list",
  FilePencil = "scha-icon-file-pencil",
  FilePlus = "scha-icon-file-plus",
  Filter = "scha-icon-filter",
  FlashlightOff = "scha-icon-flashlight-off",
  FlashlightOn = "scha-icon-flashlight-on",
  FolderOpen = "scha-icon-folder-open",
  History = "scha-icon-history",
  Home = "scha-icon-home",
  InfoCircleOutline = "scha-icon-info-circle-outline",
  InformationCircle = "scha-icon-information-circle",
  Invitation = "scha-icon-invitation",
  Lightbulb = "scha-icon-lightbulb",
  Link = "scha-icon-link",
  List = "scha-icon-list",
  Location = "scha-icon-location",
  Lock = "scha-icon-lock",
  Minus = "scha-icon-minus",
  More = "scha-icon-more",
  Newspaper = "scha-icon-newspaper",
  OpenInNew = "scha-icon-open-in-new",
  Pages = "scha-icon-pages",
  Pdf = "scha-icon-pdf",
  Pencil = "scha-icon-pencil",
  Phone = "scha-icon-phone",
  Plus = "scha-icon-plus",
  PriceTag = "scha-icon-price-tag",
  Printer = "scha-icon-printer",
  QuestionMarkCircle = "scha-icon-question-mark-circle",
  Reload = "scha-icon-reload",
  Reset = "scha-icon-reset",
  ScreenNews = "scha-icon-screen-news",
  Search = "scha-icon-search",
  Share = "scha-icon-share",
  Star = "scha-icon-star",
  Tiles = "scha-icon-tiles",
  TreeView = "scha-icon-tree-view",
  Trending = "scha-icon-trending",
  User = "scha-icon-user",
  Warning = "scha-icon-warning",
  ZcaretDown = "scha-icon-zcaret-down",
  ZcaretUp = "scha-icon-zcaret-up",
}
